import { prepProvider } from "./Provider";
import { prepSlotView } from "./SlotView";
import { prepHeader } from "./Header";
import { SocialFeedBlock } from "./blocks";
export var prepCommonPageProvider = function (pageAttributes, TimeInfoImpl) {
    return prepProvider(prepSlotView(prepHeader(pageAttributes, TimeInfoImpl), pageAttributes, [
        SocialFeedBlock.block,
    ]));
};
